import { render } from "./exit.vue?vue&type=template&id=c0b556de&ts=true"
import script from "./exit.ts?vue&type=script&lang=ts&external"
export * from "./exit.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__